import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3641b4ce"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "editor-tool-bar"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "表格", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "列头", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "支持的文件格式（.jpg, .jpeg, .gif, .png, .bmp）", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "支持的文件格式（.mp4, .ogg, .webm）", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "支持的文件格式（.csv, .doc, .docx, .xls, .xlsx, .zip, .rar, .pdf, .txt）", -1));
const _hoisted_8 = ["id"];
const _hoisted_9 = {
  class: "map-dlg-footer"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "about"
}, [/*#__PURE__*/_createElementVNode("strong", null, "VueCMF Editor"), /*#__PURE__*/_createElementVNode("div", null, "HTML5富文本编辑器"), /*#__PURE__*/_createElementVNode("div", null, "版本：1.8.0"), /*#__PURE__*/_createElementVNode("div", null, "基于MIT开源协议"), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode("特别感谢："), /*#__PURE__*/_createElementVNode("a", {
  href: "https://v3.cn.vuejs.org",
  target: "_blank"
}, "vuejs"), /*#__PURE__*/_createTextVNode(", "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://element-plus.org",
  target: "_blank"
}, "Element Plus"), /*#__PURE__*/_createTextVNode(", "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://icons.getbootstrap.com/",
  target: "_blank"
}, "Bootstrap Icons"), /*#__PURE__*/_createElementVNode("br")]), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode("© 2023 "), /*#__PURE__*/_createElementVNode("a", {
  href: "http://www.vuecmf.com",
  target: "_blank"
}, "www.vuecmf.com"), /*#__PURE__*/_createTextVNode(" All rights reserved.")])], -1));
const _hoisted_11 = {
  class: "about"
};
import { toRefs } from 'vue';
import Service from "./Service";
import { defineComponent } from 'vue';
import "bootstrap-icons/font/bootstrap-icons.css";
const __default__ = defineComponent({
  name: 'vuecmf-editor',
  components: {}
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    //编辑器ID
    id: {
      type: String,
      required: true
    },
    //编辑器内容
    content: {
      type: String,
      default: ''
    },
    //编辑器高度
    height: {
      type: String,
      default: '300px'
    },
    //自定义工具条， 多个英文逗号分隔
    tools: {
      type: String,
      default: ''
    },
    //编辑器中按钮、输入框的统一大小样式
    size: {
      type: String,
      default: 'default',
      validator: function (value) {
        return ['default', 'large', 'small'].indexOf(value) !== -1;
      }
    },
    //文件上传地址
    upload: {
      type: String,
      default: ''
    },
    //上传header中token
    token: {
      type: String,
      default: ''
    },
    //上传文件时传的额外参数
    params: {
      type: [String, Object],
      default: ''
    },
    //上传动作配置
    upload_action: {
      type: Function,
      default: null
    },
    //openai请求API地址
    openai: {
      type: String,
      default: ''
    },
    //高德地图APP_KEY
    amap_key: {
      type: String,
      default: ''
    }
  },
  emits: ['onChange'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      id,
      content,
      height,
      tools,
      upload,
      token,
      params,
      openai,
      amap_key
    } = toRefs(props);
    //初始化服务类
    const service = new Service(id, content, emit, tools?.value, upload?.value, token?.value, params?.value, openai?.value, amap_key?.value);
    const {
      image,
      //图片配置信息
      file,
      //文件配置信息
      video //视频配置信息
    } = service.getFileConfig();
    const showLinkDlg = () => service.link_dlg.value = false;
    const showTableDlg = () => service.table_dlg.value = false;
    const showImageDlg = () => service.image_dlg.value = false;
    const showVideoDlg = () => service.video_dlg.value = false;
    const showFileDlg = () => service.file_dlg.value = false;
    const showCodeDlg = () => service.code_dlg.value = false;
    const showMapDlg = () => service.map_dlg.value = false;
    const showAboutDlg = () => service.about_dlg.value = false;
    const showAIDlg = () => service.ai_dlg.value = false;
    //初始化编辑器
    service.init();
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_color_picker = _resolveComponent("el-color-picker");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_vuecmf_dialog = _resolveComponent("vuecmf-dialog");
      const _component_el_input_number = _resolveComponent("el-input-number");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(service).editor_tool_config, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: index
        }, [['heading', 'font', 'font-size'].indexOf(item.name) !== -1 ? (_openBlock(), _createBlock(_component_el_dropdown, {
          key: 0,
          onCommand: item.fun,
          trigger: "click"
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (val, idx) => {
              return _openBlock(), _createBlock(_component_el_dropdown_item, {
                command: val.key,
                key: idx
              }, {
                default: _withCtx(() => [_createElementVNode("div", {
                  innerHTML: val.value
                }, null, 8, _hoisted_2)]),
                _: 2
              }, 1032, ["command"]);
            }), 128))]),
            _: 2
          }, 1024)]),
          default: _withCtx(() => [_createVNode(_component_el_button, {
            size: __props.size,
            title: item.tips
          }, {
            default: _withCtx(() => [_createElementVNode("i", {
              class: _normalizeClass('bi ' + item.icon)
            }, null, 2)]),
            _: 2
          }, 1032, ["size", "title"])]),
          _: 2
        }, 1032, ["onCommand"])) : item.name === 'font-color' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          class: "color_btn",
          size: __props.size,
          title: item.tips
        }, {
          default: _withCtx(() => [_createVNode(_component_el_color_picker, {
            modelValue: _unref(service).color_value.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(service).color_value.value = $event),
            size: __props.size,
            onChange: item.fun,
            "show-alpha": "",
            predefine: _unref(service).predefine_colors.value
          }, null, 8, ["modelValue", "size", "onChange", "predefine"])]),
          _: 2
        }, 1032, ["size", "title"])) : item.name === 'font-bg-color' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          class: "color_btn",
          size: __props.size,
          title: item.tips
        }, {
          default: _withCtx(() => [_createVNode(_component_el_color_picker, {
            modelValue: _unref(service).bg_color_value.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(service).bg_color_value.value = $event),
            size: __props.size,
            onChange: item.fun,
            "show-alpha": "",
            predefine: _unref(service).predefine_colors.value
          }, null, 8, ["modelValue", "size", "onChange", "predefine"])]),
          _: 2
        }, 1032, ["size", "title"])) : item.name === 'link' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 3,
          size: __props.size,
          onClick: _cache[2] || (_cache[2] = $event => _unref(service).link_dlg.value = true),
          title: item.tips
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: _normalizeClass('bi ' + item.icon)
          }, null, 2)]),
          _: 2
        }, 1032, ["size", "title"])) : item.name === 'table' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 4,
          size: __props.size,
          onClick: _cache[3] || (_cache[3] = $event => _unref(service).table_dlg.value = true),
          title: item.tips
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: _normalizeClass('bi ' + item.icon)
          }, null, 2)]),
          _: 2
        }, 1032, ["size", "title"])) : item.name === 'image' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 5,
          size: __props.size,
          onClick: _cache[4] || (_cache[4] = $event => _unref(service).image_dlg.value = true),
          title: item.tips
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: _normalizeClass('bi ' + item.icon)
          }, null, 2)]),
          _: 2
        }, 1032, ["size", "title"])) : item.name === 'film' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 6,
          size: __props.size,
          onClick: _cache[5] || (_cache[5] = $event => _unref(service).video_dlg.value = true),
          title: item.tips
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: _normalizeClass('bi ' + item.icon)
          }, null, 2)]),
          _: 2
        }, 1032, ["size", "title"])) : item.name === 'file' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 7,
          size: __props.size,
          onClick: _cache[6] || (_cache[6] = $event => _unref(service).file_dlg.value = true),
          title: item.tips
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: _normalizeClass('bi ' + item.icon)
          }, null, 2)]),
          _: 2
        }, 1032, ["size", "title"])) : item.name === 'code' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 8,
          size: __props.size,
          onClick: _cache[7] || (_cache[7] = $event => _unref(service).code_dlg.value = true),
          title: item.tips
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: _normalizeClass('bi ' + item.icon)
          }, null, 2)]),
          _: 2
        }, 1032, ["size", "title"])) : item.name === 'openai' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 9,
          size: __props.size,
          onClick: _cache[8] || (_cache[8] = $event => _unref(service).ai_dlg.value = true),
          title: item.tips
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: _normalizeClass('bi ' + item.icon)
          }, null, 2)]),
          _: 2
        }, 1032, ["size", "title"])) : item.name === 'amap-map' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 10,
          size: __props.size,
          onClick: _unref(service).openAMapDlg,
          title: item.tips
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: _normalizeClass('bi ' + item.icon)
          }, null, 2)]),
          _: 2
        }, 1032, ["size", "onClick", "title"])) : item.name === 'about' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 11,
          size: __props.size,
          onClick: _cache[9] || (_cache[9] = $event => _unref(service).about_dlg.value = true),
          title: item.tips
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: _normalizeClass('bi ' + item.icon)
          }, null, 2)]),
          _: 2
        }, 1032, ["size", "title"])) : (_openBlock(), _createBlock(_component_el_button, {
          key: 12,
          size: __props.size,
          onClick: item.fun,
          title: item.tips
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: _normalizeClass('bi ' + item.icon)
          }, null, 2)]),
          _: 2
        }, 1032, ["size", "onClick", "title"]))], 64);
      }), 128))]), _createElementVNode("div", {
        class: "content",
        style: _normalizeStyle('width:100%; height:' + _unref(height)),
        contenteditable: "",
        ref: _unref(service).editor_ref
      }, null, 4), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(service).link_dlg.value,
        title: "添加超链接",
        onUpdateVisible: showLinkDlg
      }, {
        content: _withCtx(() => [_createVNode(_component_el_form, {
          size: __props.size,
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "链接地址"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(service).link_url.value,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(service).link_url.value = $event),
              placeholder: "请以http://或https://开头"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "打开方式"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(service).link_target.value,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(service).link_target.value = $event),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "新窗口",
                value: "_blank"
              }), _createVNode(_component_el_option, {
                label: "当前窗口",
                value: "_self"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["size"])]),
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "default",
          size: __props.size,
          onClick: _cache[12] || (_cache[12] = $event => _unref(service).link_dlg.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }, 8, ["size"]), _createVNode(_component_el_button, {
          type: "primary",
          size: __props.size,
          onClick: _unref(service).linkEvent
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["size", "onClick"])]),
        _: 1
      }, 8, ["model_value"]), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(service).table_dlg.value,
        title: "插入表格",
        onUpdateVisible: showTableDlg
      }, {
        content: _withCtx(() => [_createVNode(_component_el_form, {
          size: __props.size,
          inline: true
        }, {
          default: _withCtx(() => [_createElementVNode("fieldset", null, [_hoisted_3, _createVNode(_component_el_form_item, {
            label: "宽度"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: _unref(service).table_width.value,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(service).table_width.value = $event),
              precision: 0,
              step: 1,
              min: 1
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "行数"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: _unref(service).table_row.value,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _unref(service).table_row.value = $event),
              precision: 0,
              step: 1,
              min: 1
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "列数"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: _unref(service).table_col.value,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _unref(service).table_col.value = $event),
              precision: 0,
              step: 1,
              min: 1
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "边框"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_color_picker, {
              modelValue: _unref(service).table_border_color.value,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _unref(service).table_border_color.value = $event),
              "show-alpha": "",
              predefine: _unref(service).predefine_colors.value
            }, null, 8, ["modelValue", "predefine"])]),
            _: 1
          })]), _createElementVNode("fieldset", null, [_hoisted_4, _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(service).table_head.value,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _unref(service).table_head.value = $event),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "无",
                value: ""
              }), _createVNode(_component_el_option, {
                label: "第一行",
                value: "first_row"
              }), _createVNode(_component_el_option, {
                label: "第一列",
                value: "first_col"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "背景色"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_color_picker, {
              modelValue: _unref(service).table_head_bg_color.value,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => _unref(service).table_head_bg_color.value = $event),
              "show-alpha": "",
              predefine: _unref(service).predefine_colors.value
            }, null, 8, ["modelValue", "predefine"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "文字颜色"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_color_picker, {
              modelValue: _unref(service).table_head_color.value,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _unref(service).table_head_color.value = $event),
              "show-alpha": "",
              predefine: _unref(service).predefine_colors.value
            }, null, 8, ["modelValue", "predefine"])]),
            _: 1
          })])]),
          _: 1
        }, 8, ["size"])]),
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "default",
          size: __props.size,
          onClick: _cache[20] || (_cache[20] = $event => _unref(service).table_dlg.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }, 8, ["size"]), _createVNode(_component_el_button, {
          type: "primary",
          size: __props.size,
          onClick: _unref(service).insertTableEvent
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["size", "onClick"])]),
        _: 1
      }, 8, ["model_value"]), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(service).image_dlg.value,
        title: "插入图片",
        onUpdateVisible: showImageDlg
      }, {
        content: _withCtx(() => [_createVNode(_component_el_form, {
          size: __props.size,
          inline: true
        }, {
          default: _withCtx(() => [_createElementVNode("fieldset", null, [_hoisted_5, _createVNode(_component_el_form_item, {
            label: "地址"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(image).url,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => _unref(image).url = $event),
              placeholder: "请以http://或https://开头"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_unref(upload) !== undefined && _unref(upload) !== '' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [typeof __props.upload_action == 'function' ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _cache[22] || (_cache[22] = $event => __props.upload_action(_unref(image), 'editor'))
            }, {
              default: _withCtx(() => [_createTextVNode("上传")]),
              _: 1
            })) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createElementVNode("input", {
              type: "file",
              ref: _unref(service).image_form,
              class: "file-form",
              onChange: _cache[23] || (_cache[23] = fileForm => _unref(service).uploadFile(fileForm, 'image')),
              accept: ".jpg,.jpeg,.gif,.png,.bmp"
            }, null, 544), _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[24] || (_cache[24] = $event => _unref(service).triggerUpload(_unref(service).image_form.value))
            }, {
              default: _withCtx(() => [_createTextVNode("上传")]),
              _: 1
            })], 64))], 64)) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "宽度"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: _unref(image).image_width,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => _unref(image).image_width = $event),
              precision: 0,
              step: 1,
              min: 1
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "高度"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: _unref(image).image_height,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => _unref(image).image_height = $event),
              precision: 0,
              step: 1,
              min: 1
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "对齐"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(image).image_align,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => _unref(image).image_align = $event),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "左对齐",
                value: "left"
              }), _createVNode(_component_el_option, {
                label: "右对齐",
                value: "right"
              }), _createVNode(_component_el_option, {
                label: "顶对齐",
                value: "top"
              }), _createVNode(_component_el_option, {
                label: "居中对齐",
                value: "middle"
              }), _createVNode(_component_el_option, {
                label: "底对齐",
                value: "bottom"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })])]),
          _: 1
        }, 8, ["size"])]),
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "default",
          size: __props.size,
          onClick: _cache[28] || (_cache[28] = $event => _unref(service).image_dlg.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }, 8, ["size"]), _createVNode(_component_el_button, {
          type: "primary",
          size: __props.size,
          onClick: _unref(service).insertImageEvent
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["size", "onClick"])]),
        _: 1
      }, 8, ["model_value"]), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(service).video_dlg.value,
        title: "插入视频",
        onUpdateVisible: showVideoDlg
      }, {
        content: _withCtx(() => [_createVNode(_component_el_form, {
          size: __props.size,
          inline: true
        }, {
          default: _withCtx(() => [_createElementVNode("fieldset", null, [_hoisted_6, _createVNode(_component_el_form_item, {
            label: "地址"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(video).url,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => _unref(video).url = $event),
              placeholder: "请以http://或https://开头"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_unref(upload) !== undefined && _unref(upload) !== '' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [typeof __props.upload_action == 'function' ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _cache[30] || (_cache[30] = $event => __props.upload_action(_unref(video), 'editor'))
            }, {
              default: _withCtx(() => [_createTextVNode("上传")]),
              _: 1
            })) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createElementVNode("input", {
              type: "file",
              ref: _unref(service).video_form,
              class: "file-form",
              onChange: _cache[31] || (_cache[31] = fileForm => _unref(service).uploadFile(fileForm, 'video')),
              accept: ".mp4,.ogg,.webm"
            }, null, 544), _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[32] || (_cache[32] = $event => _unref(service).triggerUpload(_unref(service).video_form.value))
            }, {
              default: _withCtx(() => [_createTextVNode("上传")]),
              _: 1
            })], 64))], 64)) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "宽度"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: _unref(video).video_width,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => _unref(video).video_width = $event),
              precision: 0,
              step: 1,
              min: 1
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "高度"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: _unref(video).video_height,
              "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => _unref(video).video_height = $event),
              precision: 0,
              step: 1,
              min: 1
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "对齐"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(video).video_align,
              "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => _unref(video).video_align = $event),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "左对齐",
                value: "left"
              }), _createVNode(_component_el_option, {
                label: "居中对齐",
                value: "center"
              }), _createVNode(_component_el_option, {
                label: "右对齐",
                value: "right"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })])]),
          _: 1
        }, 8, ["size"])]),
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "default",
          size: __props.size,
          onClick: _cache[36] || (_cache[36] = $event => _unref(service).video_dlg.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }, 8, ["size"]), _createVNode(_component_el_button, {
          type: "primary",
          size: __props.size,
          onClick: _unref(service).insertVideoEvent
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["size", "onClick"])]),
        _: 1
      }, 8, ["model_value"]), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(service).file_dlg.value,
        title: "插入文件",
        onUpdateVisible: showFileDlg
      }, {
        content: _withCtx(() => [_createVNode(_component_el_form, {
          size: __props.size,
          inline: true
        }, {
          default: _withCtx(() => [_createElementVNode("fieldset", null, [_hoisted_7, _createVNode(_component_el_form_item, {
            label: "文件"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(file).url,
              "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => _unref(file).url = $event),
              placeholder: "请以http://或https://开头"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_unref(upload) !== undefined && _unref(upload) !== '' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [typeof __props.upload_action == 'function' ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _cache[38] || (_cache[38] = $event => __props.upload_action(_unref(file), 'editor'))
            }, {
              default: _withCtx(() => [_createTextVNode("上传")]),
              _: 1
            })) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createElementVNode("input", {
              type: "file",
              ref: _unref(service).file_form,
              class: "file-form",
              onChange: _cache[39] || (_cache[39] = fileForm => _unref(service).uploadFile(fileForm, 'file')),
              accept: ".csv,.doc,.docx,.xls,.xlsx,.zip,.rar,.pdf,.txt"
            }, null, 544), _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[40] || (_cache[40] = $event => _unref(service).triggerUpload(_unref(service).file_form.value))
            }, {
              default: _withCtx(() => [_createTextVNode("上传")]),
              _: 1
            })], 64))], 64)) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "下载方式"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(file).file_target,
              "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => _unref(file).file_target = $event),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "新窗口",
                value: "_blank"
              }), _createVNode(_component_el_option, {
                label: "当前窗口",
                value: "_self"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })])]),
          _: 1
        }, 8, ["size"])]),
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "default",
          size: __props.size,
          onClick: _cache[42] || (_cache[42] = $event => _unref(service).file_dlg.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }, 8, ["size"]), _createVNode(_component_el_button, {
          type: "primary",
          size: __props.size,
          onClick: _unref(service).insertFileEvent
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["size", "onClick"])]),
        _: 1
      }, 8, ["model_value"]), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(service).code_dlg.value,
        title: "插入代码",
        onUpdateVisible: showCodeDlg
      }, {
        content: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _unref(service).code_content.value,
          "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => _unref(service).code_content.value = $event),
          rows: 5,
          type: "textarea",
          placeholder: "请输入内容"
        }, null, 8, ["modelValue"])]),
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          size: __props.size,
          onClick: _cache[44] || (_cache[44] = $event => _unref(service).code_dlg.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }, 8, ["size"]), _createVNode(_component_el_button, {
          type: "primary",
          size: __props.size,
          onClick: _unref(service).insertCodeEvent
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["size", "onClick"])]),
        _: 1
      }, 8, ["model_value"]), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(service).ai_dlg.value,
        title: "AI生成内容",
        onUpdateVisible: showAIDlg
      }, {
        content: _withCtx(() => [_createVNode(_component_el_form, {
          size: __props.size,
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "需求",
            style: {
              "width": "calc(100% - 15px)"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(service).ai_question.value,
              "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => _unref(service).ai_question.value = $event),
              placeholder: "请输入您的需求"
            }, {
              append: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                onClick: _unref(service).aiGc
              }, {
                default: _withCtx(() => [_createTextVNode("生成")]),
                _: 1
              }, 8, ["onClick"])]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "内容",
            style: {
              "width": "calc(100% - 15px)"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(service).ai_content.value,
              "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => _unref(service).ai_content.value = $event),
              rows: 13,
              type: "textarea"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["size"])]),
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          size: __props.size,
          onClick: _cache[47] || (_cache[47] = $event => _unref(service).ai_dlg.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }, 8, ["size"]), _createVNode(_component_el_button, {
          type: "primary",
          size: __props.size,
          onClick: _unref(service).openaiEvent
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["size", "onClick"])]),
        _: 1
      }, 8, ["model_value"]), _createVNode(_component_vuecmf_dialog, {
        width: "70%",
        model_value: _unref(service).map_dlg.value,
        title: "高德地图",
        onUpdateVisible: showMapDlg
      }, {
        content: _withCtx(() => [_createElementVNode("div", {
          id: _unref(service).map_container.value,
          style: _normalizeStyle('width:' + _unref(service).map_info.width + '; height:' + _unref(service).map_info.height + 'px')
        }, null, 12, _hoisted_8)]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_form, {
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "地图宽度"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              class: "map-size",
              modelValue: _unref(service).map_info.width,
              "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => _unref(service).map_info.width = $event),
              title: "请输入地图宽度",
              placeholder: "请输入地图宽度"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "地图高度"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              class: "map-size",
              modelValue: _unref(service).map_info.height,
              "onUpdate:modelValue": _cache[49] || (_cache[49] = $event => _unref(service).map_info.height = $event),
              title: "请输入地图高度",
              placeholder: "请输入地图高度"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "标注名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(service).map_info.name,
              "onUpdate:modelValue": _cache[50] || (_cache[50] = $event => _unref(service).map_info.name = $event),
              title: "请输入标注名称，如公司名称",
              placeholder: "请输入标注名称，如公司名称",
              onInput: _unref(service).openMapInfoWin
            }, null, 8, ["modelValue", "onInput"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "联系方式"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              rows: "2",
              modelValue: _unref(service).map_info.contact,
              "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => _unref(service).map_info.contact = $event),
              title: "请输入联系方式",
              placeholder: "请输入标注地址，如公司地址",
              onInput: _unref(service).openMapInfoWin
            }, null, 8, ["modelValue", "onInput"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_button, {
          size: __props.size,
          onClick: _cache[52] || (_cache[52] = $event => _unref(service).map_dlg.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }, 8, ["size"]), _createVNode(_component_el_button, {
          type: "primary",
          size: __props.size,
          onClick: _unref(service).insertMapEvent
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["size", "onClick"])])]),
        _: 1
      }, 8, ["model_value"]), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(service).about_dlg.value,
        title: "关于",
        onUpdateVisible: showAboutDlg
      }, {
        content: _withCtx(() => [_hoisted_10]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
          size: __props.size,
          onClick: _cache[53] || (_cache[53] = $event => _unref(service).about_dlg.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("关闭")]),
          _: 1
        }, 8, ["size"])])]),
        _: 1
      }, 8, ["model_value"])], 64);
    };
  }
});